"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ButtonsAreaModule = _interopRequireDefault(require("../styles/components/ButtonsArea.module.css"));
var _material = require("@mui/material");
var _clear_btn = require("../icons/clear_btn");
var _DeviceGroupFilter = require("./DeviceGroupFilter");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ButtonsArea = props => {
  const {
    tabs = null,
    activeGroup,
    handleChangeRadio,
    clearFilters
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-column ".concat(_ButtonsAreaModule.default.box)
  }, (tabs === null || tabs === void 0 ? void 0 : tabs.length) > 1 ? /*#__PURE__*/_react.default.createElement(_DeviceGroupFilter.DeviceGroupFilter, {
    groupList: tabs,
    activeGroup: activeGroup,
    handleChangeRadio: handleChangeRadio
  }) : null, /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "contained",
    disableElevation: true,
    className: _ButtonsAreaModule.default.btn,
    onClick: clearFilters,
    sx: {
      backgroundColor: '#000066',
      '&:hover': {
        background: '#000066'
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_clear_btn.ClearBtnSVG, null)));
};
var _default = exports.default = ButtonsArea;